/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useEffect, useState } from "react";
import { handleCustomNoteFilling } from "../Preferences/usePreferences";
import { normalize } from "utils/capitalize";

export const ALLERGIES_OPTIONS = [
  "egg",
  "dairy",
  "fish",
  "peanuts",
  "shellfish",
  "sesame",
  "wheat",
  "nuts",
  "other",
];

const useAllergies = (companion) => {
  /* const { t } = useTranslation(); */
  const [isOtherAllergy, setHasOtherAllergy] = useState(false);

  const [formData, setFormData] = useState(() =>
    ALLERGIES_OPTIONS.reduce((sum, key) => {
      return { ...sum, [key]: { state: "initial", value: key } };
    }, {})
  );
  const [customAllergy, setCustomAllergy] = useState("");

  useEffect(() => {
    if (!companion) return;
    const _allergies = companion.allergies?.split(",");
    const customNote = handleCustomNoteFilling(companion?.allergies);
    if (customNote) {
      setHasOtherAllergy(true);
      setCustomAllergy(customNote);
    }
    _allergies?.forEach((allergy) => {
      if (allergy.startsWith("other:")) return;
      setFormData((prev) => {
        const safePref = normalize(allergy);
        return { ...prev, [allergy]: { state: "success", value: safePref } };
      });
    });
  }, [companion]);

  const handleOnChange = (text) => {
    setFormData((prev) => {
      if (prev[text]?.state === "success") {
        return { ...prev, [text]: { value: text, state: "initial" } };
      }
      return { ...prev, [text]: { value: text, state: "success" } };
    });
  };

  useEffect(() => {
    if (formData.other?.state == "success") {
      setHasOtherAllergy(true);
    } else {
      setHasOtherAllergy(false);
      setCustomAllergy("");
    }
  }, [formData]);
  return {
    isOtherAllergy,
    setHasOtherAllergy,
    customAllergy,
    handleOnChange,
    formData,
    setCustomAllergy,
  };
};

export default useAllergies;
